var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"category-title"},[_vm._v(" "+_vm._s(_vm.$t('message.categories'))+" ")]),_c('div',{ref:"stickyWrapper",staticClass:"discover-categories-buttons-wrapper"},[_c('DiscoverPanel',{staticClass:"discover-categories-buttons"})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }